import React, { useEffect, useState } from 'react';
import useDataLoader2 from '../../hooks/useDataLoader2';
import Axios from '../../utils/axios';
import { UseFirmList } from '../../hooks/Catalogs/useFirm';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import { formatTimeSpanToString } from '../../utils/functions';
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import { IEducation } from '../../interfaces/models/IEducation';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const Education: React.FC = ({ ...props }) => {
  const axios = new Axios()
  const [personData, setPersonData] = useState<any[]>([])
  const [schoolData, setSchoolData] = useState<any[]>([]) //TODO modify to use Redux and hook
  const [degreeData, setDegreeData] = useState<any[]>([]) //TODO modify to use Redux and hook
  const { firmData } = UseFirmList();
  const endpoint = '/Education';

  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    defaultSorting: { field: "person", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p> {rowIndex + 1 + pagination.pageIndex * pagination.pageSize} </p>
      ),
    },
    { id: 'firm', header: 'Firm' },
    { id: 'person', header: 'Person' },
    { id: 'school', header: 'School' },
    { id: 'degree', header: 'Degree' },
    { id: 'createdDate', header: 'Created Date' },
    {
      id: 'edit',
      header: 'Edit',
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg"><ShapeEdit /></div>
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);
  
  const formatData = (data: IEducation[]) => {
    const formatedData = data.map(d => {
      return {
        ...d,
        firm: d.firmName,
        person: d.personName,
        school: d.schoolName,
        degree: d.degreeName,
        createdDate: d.createdDate ? formatTimeSpanToString(d.createdDate) : ''
      }
    })
    return formatedData
  }

  useEffect(() => {
    // fetchPersonData()
    fetchSchoolData()
    fetchDegreeData()
  }, []);

  const fetchSchoolData = async () => {
    try {
      const response = await axios.Get('./School')
      const data = response.data
      setSchoolData(data)
    } catch (error: any) {
      console.log(error)
    }
  }

  const fetchDegreeData = async () => {
    try {
      const response = await axios.Get('./Degree')
      const data = response.data
      setDegreeData(data)
    } catch (error: any) {
      console.log(error)
    }
  }

  const filtersData: IFilterData[] = React.useMemo(() => [
    {
      name: "Firm",
      objectData: firmData?.map((f: any) => ({id: f.id, name: f.name})) || [],
    },
    {
      name: "Person",
      objectData: personData?.map(r => ({id: r.id, name: r.name})) || [],
    },
    {
      name: "School",
      objectData: schoolData?.map(r => ({id: r.id, name: r.name})) || [],
    },
    {
      name: "Degree",
      objectData: degreeData?.map(r => ({id: r.id, name: r.name})) || [],
    },
  ], [firmData, personData, schoolData, degreeData]);

  return (
    <>
      <div>
        <CatalogTableC
          title={`Education Catalog`}
          catalogName={'EDUCATIONS'}
          catalogShortName="EDUCATION"
          route={'Education'}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
              })
            }
          />
        </CatalogTableC>
      </div>
    </>
  );
};

export default Education;